"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconFocus', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10 1C9.44771 1 9 1.44772 9 2 9 2.55228 9.44771 3 10 3H11.5858L9.29289 5.29289C8.90237 5.68342 8.90237 6.31658 9.29289 6.70711 9.68342 7.09763 10.3166 7.09763 10.7071 6.70711L13 4.41421V6C13 6.55228 13.4477 7 14 7 14.5523 7 15 6.55228 15 6V2C15 1.44772 14.5523 1 14 1H10zM3 11.5858L3 10C3 9.44771 2.55228 9 2 9 1.44772 9 1 9.44771 1 10V14C1 14.2652 1.10536 14.5196 1.29289 14.7071 1.48043 14.8946 1.73478 15 2 15H6C6.55228 15 7 14.5523 7 14 7 13.4477 6.55228 13 6 13H4.41421L6.70711 10.7071C7.09763 10.3166 7.09763 9.68342 6.70711 9.29289 6.31658 8.90237 5.68342 8.90237 5.29289 9.29289L3 11.5858z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12 2C11.4477 2 11 2.44772 11 3 11 3.55228 11.4477 4 12 4L14.5858 4 11.2929 7.29294C10.9024 7.68346 10.9024 8.31663 11.2929 8.70715 11.6834 9.09767 12.3166 9.09767 12.7071 8.70715L16 5.41423 16 8C16 8.55229 16.4477 9 17 9 17.5523 9 18 8.55228 18 8L18 3C18 2.44771 17.5523 2 17 2H12zM5.41422 16H8C8.55228 16 9 16.4477 9 17 9 17.5523 8.55228 18 8 18H3C2.44772 18 2 17.5523 2 17V12C2 11.4477 2.44772 11 3 11 3.55229 11 4 11.4477 4 12L4 14.5858 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929 9.09763 11.6834 9.09763 12.3166 8.70711 12.7071L5.41422 16z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M14 3C13.4477 3 13 3.44772 13 4 13 4.55228 13.4477 5 14 5L17.5858 5 13.2929 9.29293C12.9024 9.68346 12.9024 10.3166 13.2929 10.7071 13.6834 11.0977 14.3166 11.0977 14.7071 10.7071L19 6.41423 19 10C19 10.5523 19.4477 11 20 11 20.5523 11 21 10.5523 21 10V4C21 3.44771 20.5523 3 20 3H14zM6.4142 19H10C10.5523 19 11 19.4477 11 20 11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13 4.55228 13 5 13.4477 5 14V17.5858L9.29288 13.2928C9.6834 12.9023 10.3166 12.9022 10.7071 13.2928 11.0976 13.6833 11.0976 14.3165 10.7071 14.707L6.4142 19z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M19.5 3C18.6716 3 18 3.67157 18 4.5 18 5.32843 18.6716 6 19.5 6L23.8787 6 18.4393 11.4393C17.8536 12.0251 17.8536 12.9749 18.4393 13.5607 19.0251 14.1465 19.9749 14.1465 20.5607 13.5607L26 8.12132V12.5C26 13.3284 26.6716 14 27.5 14 28.3284 14 29 13.3284 29 12.5V4.5C29 4.10217 28.842 3.72064 28.5607 3.43934 28.2794 3.15803 27.8978 3 27.5 3H19.5zM4.5 29H12.5C13.3284 29 14 28.3284 14 27.5 14 26.6716 13.3284 26 12.5 26H8.12132L13.5607 20.5607C14.1464 19.9749 14.1464 19.0251 13.5607 18.4393 12.9749 17.8536 12.0251 17.8536 11.4393 18.4393L6 23.8787 6 19.5C6 18.6716 5.32843 18 4.5 18 3.67157 18 3 18.6716 3 19.5V27.5C3 27.8978 3.15804 28.2794 3.43934 28.5607 3.72064 28.842 4.10217 29 4.5 29z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;